const Common = Object.freeze({
	General: 'sdc-settings-generalcommon',
	ShipFrom: 'sdc-settings-shippingaddresses',
	Carriers: 'sdc-settings-carriers',
	ServiceOptions: 'sdc-settings-serviceoptions',
	LabelCustomization: 'sdc-settings-labelcustomization',
});

const Mail = Object.freeze({
	General: 'sdc-settings-generalmail',
	PrintOnOptions: 'sdc-settings-printonoptions',
	RefundAssist: 'sdc-settings-refundassist',
});

const Orders = Object.freeze({
	Stores: 'sdc-settings-stores',
	International: 'sdc-settings-international',
	AutomationRules: 'sdc-settings-automationrules',
	LabelMessages: 'sdc-settings-labelmessages',
	PackingSlips: 'sdc-settings-packingslips',
});

const BrandedFeatures = Object.freeze({
	BrandSettings: 'sdc-settings-brandsettings',
});

export default {
	Common,
	Mail,
	Orders,
	BrandedFeatures,
};
